import { ComponentType } from '@angular/cdk/overlay';
import { Injectable, Injector } from '@angular/core';
import { IOverlayConfig } from '../../model';
import { OverlayAccessor, OverlayService } from '../../services';
import { DIALOG_CONFIG } from '../tokens';
import { DialogRef } from './dialog-ref';

/**
 * @description
 * handles opening & closing popup dialogs, it uses the overlay service to inherit
 * common overlay behavior and configuration and adds to it customization specific
 * to dialog overlay
 */

const DIALOG_DEFAULT_CONFIG = {
  panelClass: 'dialog-panel'
};

const DIALOG_FULL_SCREEN_CONFIG = {
  width: '90vw',
  height: '98vh',
  panelClass: 'full-screen-panel',
  buttons: {
    ok: 'סגור'
  }
};

@Injectable({
  providedIn: 'root'
})
export class DialogService extends OverlayService {
  constructor() {
    super();
  }

  /**
   * @description
   * opens a custom component in an overlay as popup dialog
   */
  override open<T>(component: ComponentType<T>, config: IOverlayConfig = {}): OverlayAccessor {
    config = Object.assign({ ...DIALOG_DEFAULT_CONFIG }, { ...config });

    if (config.isFullScreen) {
      config = Object.assign({ ...config }, { ...DIALOG_FULL_SCREEN_CONFIG });
    }

    return super.open<T>(component, config);
  }

  /**
   * @description
   * creates an injector specifically for the overlay component. in order to inject the dialog
   * ref & config into the
   * @param overlayRef a dialog reference class exposing dialog options to the dialog component
   * @param overlayConfig a dialog config object specifying data & ui settings
   * @returns an injector with providers for the overlay dialog
   */
  override createInjector(overlayRef: OverlayAccessor, overlayConfig: IOverlayConfig): Injector {
    return Injector.create({
      parent: this.injector,
      providers: [
        { provide: DialogRef, useValue: overlayRef },
        { provide: DIALOG_CONFIG, useValue: overlayConfig }
      ]
    });
  }
}
